export const viewCard_style = {
  rootSx: {
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'grey.400',
    boxShadow: 'none',
    // bgcolor: '#000',
    // p: 1.5,
  },
  labelSx: {
    color: '#868484',
    fontSize: '12px',
    // margin: '0px 2px',
    fontWeight: 600,
  },
  appointmentCardSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'inherit',
  },
  appointmentDocCardSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pt: 1.36,
  },
  doctornameSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  selfSx: {
    fontSize: '12px!important',
    color: 'text.secondary',
    pt: 0.3,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
  },
  btnSx: {
    backgroundColor: 'common.white',
    color: 'primary.main',
    borderRadius: '6px',
    border: '2px solid',
    borderColor: 'border.focus',
    textTransform: 'none',
    boxShadow: 'none',
    px: 2.25,
    py: 0.8,
    width: '108px',
    '&.Mui-disabled': {
      border: '2px solid #E2E2E2',
      backgroundColor: 'transparent',
    },
    '&:hover': {
      color: 'common.white',
    },
  },
  referchangingSx: {
    borderRadius: '4px',
    fontWeight: 600,
    px: 0.4,
    mx: 0.75,
    width: 'max-content',
  },
  morelistSx: {
    '& .MuiPopover-paper': {
      boxShadow: '0px 0px 7px 1px #b7b7b7',
    },
    '& .MuiMenu-list.css-6hp17o-MuiList-root-MuiMenu-list': {
      padding: '0px',
    },
  },
  borderSx: {
    fontSize: '12px',
    fontWeight: 600,
    margin: 0,
    color: 'error.main',
    borderRadius: '8px',
    p: 1.5,
    '&:hover': {
      backgroundColor: 'common.white',
    },
  },
  profilepicSx: {
    width: '44px',
    height: '44px',
  },
  cancelAppointment: {},
  professionalContainSx: {
    display: 'flex',
    flexWrap: 'wraps',
    flexFlow: 'wrap',
    width: '200px',
  },
  professionalSx: {
    color: 'text.hint',
    fontSize: '12px',
    pt: 0.25,
    whiteSpace: 'nowrap',
  },
  typeSx: {
    display: 'flex',
    alignItems: 'start',
    pt: 0.45,
  },
  patientAndDateSx: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 0px',
  },
};
